import { render, staticRenderFns } from "./ClinicShowProduct.vue?vue&type=template&id=46308edb"
import script from "./ClinicShowProduct.vue?vue&type=script&lang=js"
export * from "./ClinicShowProduct.vue?vue&type=script&lang=js"
import style0 from "./ClinicShowProduct.vue?vue&type=style&index=0&id=46308edb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports